import { createPluginFactory } from '@udecode/plate';

import { BufferEditor, BufferValue } from '~/editor/BufferEditor/types.plate';
import { isSelectionAtEndOfCurrentNode } from '~/editor/queries/isSelectionAtEndOfNode';
import {
  AutocompleteInputElementUI,
  AutocompletePluginOptions,
} from '../autocomplete';
import { normalizeMention } from '../autocomplete/commands/normalizeMention';
import { onMentionUpdated } from '../autocomplete/commands/onMentionUpdated';
import { autocompleteOnKeyDownHandler } from '../autocomplete/handlers';
import { replaceTextAfterTriggerWithMention } from '../autocomplete/transforms/replaceTextAfterTriggerWithMention';
import { withAutocomplete } from '../autocomplete/withAutocomplete';
import { getNewSuggestionsOnMentionUpdate } from './commands/getNewSuggestionsOnMentionUpdate';
import { TwitterMentionInputElement } from './nodes/TwitterMentionInputElement';
import { findAndCreateTwitterMentions } from './transforms/findAndCreateTwitterMentions';

/**
 * Twitter mention plugin factory.
 * Overrides and configures Autocomplete plugin.
 */
export const createTwitterMentionPlugin = createPluginFactory<
  AutocompletePluginOptions<TwitterMentionInputElement>,
  BufferValue,
  BufferEditor
>({
  key: TwitterMentionInputElement.type,
  isElement: true,
  isInline: true,
  component: AutocompleteInputElementUI,
  options: {
    textToNodes: findAndCreateTwitterMentions,
    onPastedText: findAndCreateTwitterMentions,
    fetchNewSuggestions: getNewSuggestionsOnMentionUpdate,
    onInsertTriggerBeforeText: replaceTextAfterTriggerWithMention,
    shouldExitOnWhitespace: isSelectionAtEndOfCurrentNode,
    onMentionUpdated,
    normalizeNode: (editor, nodeEntry) =>
      normalizeMention(editor, TwitterMentionInputElement, nodeEntry),
  },
  withOverrides: withAutocomplete<TwitterMentionInputElement>(
    TwitterMentionInputElement
  ),
  handlers: {
    onKeyDown: autocompleteOnKeyDownHandler({
      type: TwitterMentionInputElement.type,
      exitOnWhitespace: true,
    }),
  },
});
